import Flex from '@deprecated-ui/common/Flex';
import { IconWrapper } from '@deprecated-ui/common/Iconmoon';
import Image from 'global/Image';
import { ButtonTrading, TextLabel } from './styled';

interface ButtonTradingOutlineProps {
  isActive: boolean;
  isOpen: boolean;
  minimize: boolean;
  label: string;
  imageSrc: string;
  onChangeVisibility?: (active: boolean) => void;
}

const ButtonTradingOutline = ({
  isActive,
  isOpen,
  minimize,
  label,
  imageSrc,
  onChangeVisibility,
}: ButtonTradingOutlineProps) => (
  <ButtonTrading
    data-cy="real-trading-btn"
    isActive={isActive && isOpen}
    minimize={minimize}
    onClick={() => onChangeVisibility(!isActive)}
  >
    <IconWrapper size={minimize ? '20px' : '40px'}>
      <Image src={imageSrc} alt="" style={{ width: '100%' }} />
    </IconWrapper>
    <Flex align="space-between" style={{ gap: '4px' }}>
      <TextLabel minimize={minimize}>{label}</TextLabel>

      <Image
        className="arrow"
        src="/icon/chevron-down.svg"
        alt=""
        width={18}
        height={18}
      />
    </Flex>
  </ButtonTrading>
);

export default ButtonTradingOutline;
